import { HomeData } from "../shared/types";

export const homeData: HomeData = {
  intro: {
    title: "Una nave pirata nell'arcipelago delle vanità",
    subtitle:
      "MAGOG è un gruppo editoriale che riunisce quattro testate giornalistiche, che oltre a produrre contenuti esclusivi e inediti quotidiani, pubblica libri, organizza eventi di vario genere, smuove le coscienze, sposta le masse, spariglia le idee.",
  },
  whatWeDo: [
    {
      title: "Giornalismo",
      product: ["Dissipatio", "Pangea", "Blast", "Bubble Report"],
      image: "wwd-1.png",
    },
    {
      title: "Editoria",
      product: [
        "Proiettili",
        "Collana Aphinar",
        "Collana La Matta",
        "Collana Visibile",
        "Collana Invisibile",
      ],
      image: "wwd-2.png",
    },
    {
      title: "Eventi",
      product: [
        "Bayram – Il tempo della cosmipolitica",
        "I Martedì di Dissipatio",
        "Pangea a Teatro",
      ],
      image: "wwd-4.png",
    },
  ],
  numbers: [
    {
      amount: "+13M",
      desc: "Pagine visualizzate all'anno",
    },
    {
      amount: "+35K",
      desc: "Utenti unici al giorno",
    },
    {
      amount: "+300",
      desc: "Ospiti e firme",
    },
    {
      amount: "+210K",
      desc: "Follower sui social",
    },
    {
      amount: "200",
      desc: "Eventi organizzati",
    },
  ],
  phares: [
    {
      title: '"Come una nuvola che copre la terra"',
      desc: "MAGOG è il sigillo di una profezia; è il punto violaceo di incontro e di esplosione di un  percorso multilaterale di realtà culturali  che sono nate, cresciute ed evolute nel tempo, ognuna con la sua identità, seppur con lo stesso spirito corsaro; è un patto tra uomini, donne, animali sovrannaturali che vengono dal sottosuolo, vivono tra le nuvole, lottando contro le tenebre.",
    },
    {
      title: '"Il loro numero è come la sabbia del mare"',
      desc: "MAGOG è un gruppo editoriale; è un dialogo costante tra riviste che si muovo tra il digitale e l'analogico, tra la fisica e la metafisica; è un'invettiva contro lo spirito del tempo che vuole sfidarlo a duello con le armi della guerriglia culturale.",
    },
    {
      title: '"Portano grande disordine sulla terra!"',
      desc: 'MAGOG è un cenacolo, un censimento e un fuoco, un caravanserraglio e un rifugio di fuggiaschi; è una radice, come suggerisce la lingua araba, "il luogo in cui" si sa qual è la direzione, ci si muove giocando a dadi con le stelle, senza altra esigenza che la meraviglia, con uno sguardo fiero, culturale, politico. che non attende il "dibattito" ma si dibatte nel viaggio, nell\'impresa. Soprattutto è una nazione autarchica, un monastero e una legione; "ottimizza i tempi", non opera previsioni elettorali e non adotta una visione utilitaristica: fa il giro del mondo, raccoglie le erbe curative, conosce lo scintillio delle vipere, osserva il cerchio dei falchi. Alla ragione – che genera mostri – antepone l\'esigenza del miracolo.',
    },
  ],
  press: [
    {
      title: "Nasce il Gruppo Editoriale MAGOG  S.R.L",
      desc: "Nasce ufficialmente il \"Gruppo Editoriale MAGOG S.R.L\", con sede operativa a Palazzo del Drago (centro storico di Roma), che riunisce quattro testate giornalistiche online (Dissipatio, Pangea, Contrasti e Blast), e promuove una casa editrice (GOG Edizioni), una scuola di formazione in giornalismo, editoria e nuovi media (GEM), un festival dell'editoria e del giornalismo (Libropolis). Tutte realtà editoriali e culturali consolidate nel tempo, nate in autonomia, che operano in diversi campi, dall'informazione alla formazione passando per la comunicazione e l'editoria, che hanno deciso di intraprendere un'avventura comune e condivisa dai Fondatori Sebastiano Caputo (presidente del Cda) e Lorenzo Vitelli (Consigliere, direttore editoriale di GOG Edizioni). ",
      date: "25 febbraio 2022",
    },
    {
      title: "La rivista Pangea entra nel Gruppo Editoriale MAGOG",
      desc: "Pangea, rivista avventuriera di cultura e idee, fondata nel 2016 e diretta da Davide Brullo, entra a far parte del Gruppo Editoriale MAGOG S.R.L. E da maggio 2022 inaugurerà la sua collana editoriale in formato E-Book nel solco delle pubblicazioni quotidiane, con testi introvabili e inediti, tradotti integralmente in italiano.  ",
      date: "25 febbraio 2022",
    },
    {
      title: "Nasce Dissipatio",
      desc: "Dissipatio è una cellula mediatica, fondata nel 2022 e diretta da Sebastiano Caputo, che si muove nello spaziotempo della letteratura e del potere attraverso la produzione di approfondimenti, analisi e scenari strettamente collegati all'attualità quanto alle meccaniche dello spirito della nostra epoca.",
      date: "25 febbraio 2022",
    },
    {
      title: "Nasce Blast",
      desc: "Un blog cyberpunk e dadaista, fondato nel gennaio 2022 e diretto nell'anonimato da un collettivo di ragazze e ragazzi nati nel 2000, che attraverso la scrittura creativa e visiva, esplora nuovi linguaggi, e affronta temi virali, di tendenza, di agitazione.",
      date: "25 febbraio 2022",
    },
    {
      title: "Contrasti X Guerin Sportivo ",
      desc: "Debutta la collaborazione di Contrasti con la rivista sportiva più antica del mondo: il Guerin Sportivo. Tutte le settimane sul sito del Guerino, e tutti i mesi sulla rivista cartacea, ci sarà uno spazio dedicato esclusivamente alla pubblicistica di Contrasti. ",
      date: "25 febbraio 2022",
    },
    {
      title:
        "La sesta edizione di Libropolis si svolgerà dal 7 al 9 ottobre 2022",
      desc: "Il Consiglio Direttivo di Libropolis, con il patrocinio del Comune di Pietrasanta, ha deciso che la Sesta Edizione del Festival si svolgerà dal 7 al 9 Ottobre 2022 al chiostro di Sant'Agostino Pietrasanta. Come ogni anno, saranno tre giorni immersi nel mondo dell'editoria, in compagnia dei grandi nomi del giornalismo e della cultura italiana, con conferenze e presentazioni di libri per capire il mondo moderno e le sue trasformazioni. ",
      date: "25 febbraio 2022",
    },
  ],
};
